var app = angular.module('directives.mobileDropdown', []);

require('./directives/mobileDropdown.js');
require('./templates/mobileDropdown.html');
require('./stylesheet/index.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/mobileDropdown/index.js
 ** module id = 188
 ** module chunks = 1
 **/